import React from 'react';
import { ResponsivePie } from '@nivo/pie';

const MyResponsivePie = ({ data, isInteractive }) => (
  <ResponsivePie
    data={data}
    margin={{
 top: 20, right: 10, bottom: 20, left: 10,
}}
    pixelRatio={1}
    startAngle={-43}
    innerRadius={0.7}
    cornerRadius={2}
    colors={{ datum: 'data.color' }}
    borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
    radialLabelsSkipAngle={16}
    radialLabelsTextXOffset={6}
    radialLabelsTextColor="#333333"
    radialLabelsLinkOffset={-4}
    radialLabelsLinkDiagonalLength={16}
    radialLabelsLinkHorizontalLength={18}
    radialLabelsLinkStrokeWidth={1}
    radialLabelsLinkColor={{ from: 'color' }}
    enableRadialLabels={false}
    enableSlicesLabels={false}
    slicesLabelsSkipAngle={10}
    slicesLabelsTextColor="#333333"
    animate
    motionStiffness={90}
    motionDamping={15}
    isInteractive={isInteractive}

    defs={[
            {
                id: 'dots',
                type: 'patternDots',
                background: 'inherit',
                color: 'rgba(255, 255, 255, 0.3)',
                size: 4,
                padding: 1,
                stagger: true,
            },
            {
                id: 'lines',
                type: 'patternLines',
                background: 'inherit',
                color: 'rgba(255, 255, 255, 0.3)',
                rotation: -45,
                lineWidth: 6,
                spacing: 10,
            },
        ]}
    fill={[
            {
                match: {
                    id: 'ruby',
                },
                id: 'dots',
            },
            {
                match: {
                    id: 'c',
                },
                id: 'dots',
            },
            {
                match: {
                    id: 'go',
                },
                id: 'dots',
            },
            {
                match: {
                    id: 'python',
                },
                id: 'dots',
            },
            {
                match: {
                    id: 'lisp',
                },
                id: 'lines',
            },
            {
                match: {
                    id: 'elixir',
                },
                id: 'lines',
            },
            {
                match: {
                    id: 'javascript',
                },
                id: 'lines',
            },
        ]}


  />
);


export default MyResponsivePie;
